import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { ModalComponent, NavButtonComponent } from "@evc/web-components";
import { TranslatePipe } from "@ngx-translate/core";
import { EVC_MODAL_DATA } from "../../services/modal/evc-modal.service";

type ConfirmationProps = { mainLabel: string; secondaryLabel?: string };
@Component({
  selector: "app-confirmation-modal",
  standalone: true,
  imports: [CommonModule, ModalComponent, NavButtonComponent, TranslatePipe],
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"]
})
export class ConfirmationModalComponent {
  constructor(@Inject(EVC_MODAL_DATA) public props: ConfirmationProps) {}

  @Output() confirm = new EventEmitter<boolean>();
  @Output() reject = new EventEmitter<void>();
}
